import { useEffect, useState } from 'react';
import './App.css';
import * as fallback from './content/fallback';
import { fetchServices, fetchPortfolio } from './api';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import DigitalTools from './components/DigitalTools';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  // Company profile is a frozen config on the backend — bundled copy is fine.
  const company = fallback.company;

  // Services & portfolio are DB-backed and admin-editable: fetch live, fall
  // back to bundled seed content on any failure so first paint is never empty.
  const [services, setServices] = useState(fallback.services);
  const [portfolio, setPortfolio] = useState(fallback.portfolio);

  useEffect(() => {
    const controller = new AbortController();
    const opts = { signal: controller.signal };

    fetchServices(opts).then((data) => {
      if (Array.isArray(data) && data.length > 0) setServices(data);
    });
    fetchPortfolio(opts).then((data) => {
      if (Array.isArray(data) && data.length > 0) setPortfolio(data);
    });

    return () => controller.abort();
  }, []);

  return (
    <>
      <Navbar companyName={company.name} />
      <main>
        <Hero company={company} />
        <Services services={services} currency={company.contact?.currency} />
        <DigitalTools services={services} />
        <Portfolio portfolio={portfolio} />
        <About company={company} />
        <Contact company={company} />
      </main>
      <Footer company={company} />
    </>
  );
}

export default App;
